import { render, staticRenderFns } from "./compareTemp.vue?vue&type=template&id=6d8c0c6e&scoped=true"
import script from "./compareTemp.vue?vue&type=script&lang=js"
export * from "./compareTemp.vue?vue&type=script&lang=js"
import style0 from "./compareTemp.vue?vue&type=style&index=0&id=6d8c0c6e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8c0c6e",
  null
  
)

export default component.exports